import React from 'react'
import reactStamp from 'react-stamp'

import AppointmentsHistory from './AppointmentsHistory'
import AppointmentsBooking from './AppointmentsBooking'
import MediaQuery from 'react-responsive'

import './appointments.css'

export default reactStamp(React).compose({

    render() {
        let {
            active,
            putSchedule,
            handleProviderSelect,
            daysWithFreeSlots,
            practitioners,
            upcomingAppointments,
            appointmentsHistory,
            ...routes
        } = this.props;

        switch (active) {
            case "history":
                return (
                    <div className="appointments-container">
                        <MediaQuery minWidth={920}>
                            <AppointmentsHistory 
                                upcomingAppointments={upcomingAppointments} 
                                appointmentsHistory={appointmentsHistory} 
                                {...routes}
                            />
                        </MediaQuery>
                        <MediaQuery maxWidth={920}>
                            <AppointmentsHistory 
                                upcomingAppointments={upcomingAppointments} 
                                appointmentsHistory={appointmentsHistory} 
                                single={true} 
                                {...routes}
                            />
                        </MediaQuery>
                    </div>
                )
                break;
            case "booking":
                return (
                    <div className="appointments-container">
                        <MediaQuery maxWidth={700}>
                            <AppointmentsBooking 
                                single={true} 
                                practitioners={practitioners}
                                daysWithFreeSlots={daysWithFreeSlots}
                                handleProviderSelect={handleProviderSelect}
                                putSchedule={putSchedule}
                                {...routes}
                            />
                        </MediaQuery>
                        <MediaQuery minWidth={700}>
                            <AppointmentsBooking 
                                practitioners={practitioners}
                                daysWithFreeSlots={daysWithFreeSlots}
                                handleProviderSelect={handleProviderSelect}
                                putSchedule={putSchedule}
                                {...routes}
                            />
                        </MediaQuery>
                    </div>
                )
        }

    }

});




/** WEBPACK FOOTER **
 ** ./src/app/components/Appointments/index.js
 **/